import { ColumnDef, ColumnHelper } from '@tanstack/react-table'

import { commonAccessorColumn, moneyAccessorColumn } from '@/components/table'
import { AcqPaymentStatus, RefundAcqButton } from '@/components'
import { AcqPayment } from '@/types.ts'

export const KEY_PAGE = 'acquiring'

type VisibleColumns =
  | 'id'
  | 'reference'
  | 'date'
  | 'clientFio'
  | 'pan'
  | 'state'
  | 'amount'
  | 'amountReturn'
  | 'comissionPayer'
  | 'comissionReceiver'
  | 'commissionITO'
  | 'amountIncomeClient'
  | 'amountIncomeMerchant'

export type PartialAcqPayment = Pick<AcqPayment, VisibleColumns>

export const defaultSettings: Record<keyof PartialAcqPayment, string> = {
  id: '№ заказа',
  reference: '№ заказа магазина',
  date: 'Дата создания',
  clientFio: 'Клиент',
  pan: 'Номер карты',
  state: 'Статус',
  amount: 'Сумма',
  amountReturn: 'Сумма возврата',
  comissionPayer: 'Комиссия с клиента',
  comissionReceiver: 'Комиссия с магазина',
  commissionITO: 'Комиссия ИТО',
  amountIncomeClient: 'Сумма к зачислению клиенту',
  amountIncomeMerchant: 'Сумма к зачислению магазину',
}

export function getColumnsSettings(
  columnHelper: ColumnHelper<AcqPayment>
): Record<keyof PartialAcqPayment, ColumnDef<AcqPayment, any>> {
  return {
    id: columnHelper.accessor('id', commonAccessorColumn('№ заказа')),
    reference: columnHelper.accessor('reference', commonAccessorColumn('№ заказа магазина')),
    // todo: какая таймзона?
    date: columnHelper.accessor('date', commonAccessorColumn('Дата создания')),
    clientFio: columnHelper.accessor('clientFio', commonAccessorColumn('Клиент')),
    pan: columnHelper.accessor('pan', commonAccessorColumn('Номер карты')),
    state: columnHelper.accessor('state', {
      header: 'Статус',
      cell: (props) => <AcqPaymentStatus state={props.getValue()} />,
    }),
    // todo: поменять валюту rur на rub?
    amount: columnHelper.accessor('amount', moneyAccessorColumn('Сумма')),
    amountReturn: columnHelper.accessor('amountReturn', moneyAccessorColumn('Сумма возврата')),
    comissionPayer: columnHelper.accessor('comissionPayer', moneyAccessorColumn('Комиссия с клиента')),
    comissionReceiver: columnHelper.accessor('comissionReceiver', moneyAccessorColumn('Комиссия с магазина')),
    commissionITO: columnHelper.accessor('commissionITO', moneyAccessorColumn('Комиссия ИТО')),
    amountIncomeClient: columnHelper.accessor('amountIncomeClient', moneyAccessorColumn('Сумма к зачислению клиенту')),
    amountIncomeMerchant: columnHelper.accessor(
      'amountIncomeMerchant',
      moneyAccessorColumn('Сумма к зачислению магазину')
    ),
  }
}

export const getStaticColumns = (
  columnHelper: ColumnHelper<AcqPayment>
): Record<string, ColumnDef<AcqPayment, any>> => {
  return {
    'refund-action': columnHelper.display({
      id: 'refund-action',
      enableSorting: false,
      cell: (props) => <RefundAcqButton {...props.row.original} />,
    }),
  }
}
